<template>
  <div>
    <agile-table
      :data-type="'customers'"
      :data="customers"
      :tableMeta="tableMeta"
      :filter-meta="filterMetaFinal"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      @rowAction="rowAction"
      @fieldAction="fieldAction" />
    <new-button @clicked="openCustomerModal" />
    <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import AgileTable from '@/components/table/AgileTable'
import CustomerModal from '@/components/modals/CustomerModal'
import { getProductName } from '@/helpers'

export default {
  components: {
    NewButton,
    AgileTable
  },

  props: {
    title: {
      type: String,
      required: false
    },

    filterMeta: {
      type: Array,
      required: false
    },

    resellerId: {
      type: Number,
      required: false
    }
  },

  data () {
    return {
      display: false,
      debounceDelay: process.env.DEBOUNCE_DELAY,
      filterMetaFinal: [],
      tableMeta: {
        title: this.title,
        headingIcon: 'fa-building'
      },

      filterMetaDefault: [{
        fieldId: 'name',
        type: 'string',
        label: 'Kund'
      },
      {
        fieldId: 'organizationNumber',
        type: 'string',
        label: 'Organisationsnummer'
      }
      ],

      columnMeta: {
        hasActions: true,
        items: [
          {
            fieldId: 'name',
            label: 'Företag'
          },
          {
            fieldId: 'organizationNumber',
            label: 'Org. nr.'
          },
          {
            fieldId: 'licenses',
            label: 'Licenser',
            dataType: 'callback',
            callback: (item) => {
              if (!item.licenses || item.licenses.length === 0) {
                return '-'
              }
              return item.licenses.map(x => getProductName(x.product)).join(', ')
            }
          }
        ]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Redigera kund',
          action: 'updateCustomer',
          iconClass: 'fal fa-pen'
        }, {
          label: 'Licenser',
          action: 'goToLicensesPage',
          iconClass: 'fal fa-file-certificate'
        }, {
          label: null,
          action: 'deleteCustomer',
          iconClass: 'fal fa-xmark',
          buttonClass: 'is-danger'
        }]
      }
    }
  },

  watch: {
    'customers.filter': {
      handler () {
        this.$store.state.customers.all.currentPage = 1
        this.getListData()
      },
      deep: true
    }
  },

  computed: {
    ...mapState({
      customers: state => state.customers.all
    })
  },

  methods: {
    ...mapActions('customers', ['initialize', 'getListData', 'delete']),

    rowAction (action, customer) {
      switch (action) {
        case 'updateCustomer':
          this.openCustomerModal(customer.customerId)
          break
        case 'deleteCustomer':
          this.deleteCustomer(customer)
          break
        case 'goToLicensesPage':
          this.goToLicensesPage(customer)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, customer) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    openCustomerModal (customerId) {
      this.$panel(CustomerModal, { customerId, resellerId: this.resellerId })
    },

    goToLicensesPage (customer) {
      this.$router.push({ name: 'CustomerLicenses', params: { customer: customer, customerId: parseInt(customer.customerId) } })
    },

    deleteCustomer (customer) {

      if (customer.licenses && customer.licenses.length) {
        this.$alertOptions({ title: 'Kan inte ta bort kund', text: `${customer.name} har licenser. Om du vill ta bort kunden får du ta bort licenserna först`, icon: 'error' })
        return
      }

      this.$confirm('Radera kund', 'Är du säker på att du vill radera kunden ' + customer.name + '?').then((result) => {
        if (result.value) {
          this.delete(customer.customerId)
          this.getListData(1)
        }
      })
    }
  },

  created () {
    this.initialize()

    if (this.resellerId) {
      this.customers.defaultFilter.resellerId = this.resellerId
      this.customers.filter.resellerId = this.resellerId
    }
    else {
      this.customers.defaultFilter.resellerId = null
      this.customers.filter.resellerId = null
    }

    if (this.filterMeta === null) {
      this.filterMetaFinal = null
    }
    else if (this.filterMeta) {
      this.filterMetaFinal = this.filterMeta
    }
    else {
      this.filterMetaFinal = this.filterMetaDefault
    }

    this.getListData().then(() => {
      this.display = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/Customer/CustomersPage.vue